/**
 * Design System - Breakpoint Tokens
 * Sistema responsive standardizzato
 */

export const breakpoints = {
  // Breakpoint values (in px)
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
} as const;

// Material-UI breakpoint values
export const breakpointValues = {
  xs: breakpoints.xs,
  sm: breakpoints.sm,
  md: breakpoints.md,
  lg: breakpoints.lg,
  xl: breakpoints.xl,
} as const;

// Media query helpers
export const mediaQueries = {
  up: (breakpoint: keyof typeof breakpoints) => {
    const value = breakpoints[breakpoint];
    return `@media (min-width: ${value}px)`;
  },
  down: (breakpoint: keyof typeof breakpoints) => {
    const value = breakpoints[breakpoint];
    return `@media (max-width: ${value - 1}px)`;
  },
  between: (start: keyof typeof breakpoints, end: keyof typeof breakpoints) => {
    const startValue = breakpoints[start];
    const endValue = breakpoints[end];
    return `@media (min-width: ${startValue}px) and (max-width: ${endValue - 1}px)`;
  },
} as const;

// Container max widths
export const containerMaxWidths = {
  xs: '100%',
  sm: '600px',
  md: '900px',
  lg: '1200px',
  xl: '1536px',
} as const;
